import React from "react";
import { useRecoilState } from "recoil";

import {
	FormControl,
	FormLabel,
	FormControlLabel,
	Radio,
	RadioGroup,
} from "@mui/material";

import { VISITOR_AND_SPEND_TYPES, visitorAndSpendTypeAtom } from './atoms'

export default function TravelTypeSelector() {
	const [visitorAndSpendType, setVisitorAndSpendType] = useRecoilState(visitorAndSpendTypeAtom)
  const [selectedTypeId, setSelectedTypeId] = React.useState(visitorAndSpendType.id)
  const [timer, setTimer] = React.useState(null)

  const updateType = (e) => {
  	clearTimeout(timer);
  	setSelectedTypeId(e.target.value)
  };

  const afterTimeout = () => {
  	const type = VISITOR_AND_SPEND_TYPES.find((type) => type.id === selectedTypeId)
    setVisitorAndSpendType(type)
  }

  React.useEffect(() => {
		const t = setTimeout(afterTimeout, 100);
		setTimer(t)
  }, [selectedTypeId])

  const renderRadioButton = (type) => {
  	return (
  		<Radio
  			aria-label={type.label}
  			size="small" />
  	)
  }

	const renderRadioControl = (type) => (
		<FormControlLabel
			key={type.id}
			control={renderRadioButton(type)}
			value={type.id}
			label={type.label}
			sx={{
				width: "180px",
				marginBottom: -1,
			}}/>
	)

	return (
		<FormControl sx={{
			mb: 2,
			ml: 3,
		}}>
			<FormLabel
				id="visitor-and-spend-type-label"
				sx={{
					fontSize: "11px",
					color: '#868b8e',
					marginBottom: '2px',
				}}>
				Type
			</FormLabel>
			<RadioGroup
				row
				name="visitor-and-spend-type-option"
				aria-labelledby="visitor-and-spend-type-label"
				defaultValue={visitorAndSpendType.id}
				onChange={updateType}>
				{VISITOR_AND_SPEND_TYPES.map((type) => renderRadioControl(type))}
			</RadioGroup>
		</FormControl>
	)
}